import React from 'react';
import { withRouter } from 'react-router';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';
import { Button } from 'react-md';

import './FAQ.css';


export default withRouter(injectIntl(({ history }) => (

  <div className="FAQ-main">
    <div className="privacy-text">
      <FormattedHTMLMessage id="faq.faq_message.message" />
    </div>
    <Button className="back-button" onClick={() => history.goBack()}>Back</Button>
  </div>
)));



// WEBPACK FOOTER //
// ./src/components/FAQ.jsx